export enum AgentVerificationStatus {
  'Verified' = 'Verified',
  'Pending' = 'Pending',
  'Denied' = 'Denied',
  'Revoked' = 'Revoked',
}
